import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
    SalesOrderService,
    ComboService,
    Combo2Service
} from "../../../services/index";

@Component({
    selector: "addEdit-SalesReturn-Bundle",
    host: { "(window:keydown)": "hotkeys($event)" },
    templateUrl: "./addFactoryProdPlan.html",
})
export class addFactoryProdPlan {
    teamList = ["PRIME", "PREMIUM"];
    list = [];
    agentList = [];
    // monthList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    monthList = ["NOV", "DEC","JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT"]
    ngModelValue: any
    mode: string;
    saveEvent: any;
    tot_qty: any;
    tot_days: any;
    tot_avg: any;
    isLoading: boolean = false;
    month_data: any;
    finyearList = [];
    checklist = [];
    calendar_plan: boolean = false;
    production_plan: boolean = true;
    masterData: any = {
        entry_by: '',
        finyear: '',
        fin_id: '',
        effective_from: new Date()
    };

    filter: any = {};
    calendarData: any = [];
    filter1: any = {};
    options = { year: 'numeric', month: 'short', };
    agentData = [];

    @Input() _params: any;
    @Input() active = false;

    @Input() set params(val: any[]) {
        this._params = val;
        this.mode = val["mode"];
        this.saveEvent = val["data"].tabevent;
        let designdata = Object.assign({}, val["data"]);
        let Year_data = Object.assign({}, val["Year_data"]);

        if (this.mode == "View" || this.mode == "Edit") {
            this.viewProdPlanlist(designdata.fin_id)
            this.masterData = designdata;
        }
    }

    get params(): any[] {
        return this._params;
    }
    @Output() tabUpdateEvent = new EventEmitter();
    @ViewChild("widthAuto") widthAuto;
    widthCtrl: FormControl = new FormControl();
    partyCtrl: FormControl = new FormControl();
    qualityCtrl: FormControl = new FormControl();
    invdtControl: FormControl = new FormControl();
    parentCtrl: FormControl = new FormControl();
    constructor(
        public store: Store<fromRootStore.State>,
        public datePipe: DatePipe,
        public toasterService: ToasterService,
        private salesservice: SalesOrderService,
        private comboservice: ComboService,
        private combo2service: Combo2Service,
    ) { }
    ngOnInit() {

       if(this.mode == 'Add')
        this.finyearCombo();
  
    }

    hotkeys(event) {
        if (this.active) {
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            $("#ret_date").focus();
        }, 100);
    }
    onEnterKeyPressed(nextEl: string, ind, item) {
        if ($(".swal2-container").length > 0) {
            return false;
        } else {
            let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
            a.removeClass("mat-autocomplete-visible");
            setTimeout(() => {
                $("#" + nextEl).focus();
            }, 100);

        }
    }
    onGoToNextFld($event, fld, ind) {

        let nxtInd = ind;
        let nxtRow = $("#row-" + ind).next("tr");
        if (fld == "bar" && nxtRow.length == 0) {
            let rowdetail = Object.assign({}, ind);
            nxtInd = nxtInd + 1;
            $("#" + "bar" + "-" + nxtInd).focus();
        } else {
            setTimeout(() => {
                let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
                a.removeClass("mat-autocomplete-visible");
                $("#" + fld + "-" + nxtInd).focus();
            }, 100);
        }
    }
    getPartyList() {
        let params = {
            page: 1,
            start: 0,
            limit: 100,
        };

    }
    Selectqty(i) {
        this.tot_qty = 0;
          this.tot_days = 0;
        this.tot_avg = 0;
        this.agentData[i].avg_qty = (this.agentData[i].plan_qty / this.agentData[i].work_days).toFixed(0);
        this.agentData.forEach(e => {
            this.tot_qty += e.plan_qty;
            this.tot_days += e.work_days;
      

        });
           this.tot_avg =  (this.tot_qty / this.tot_days).toFixed(0)
    }

    onGoToUpAndDown($event, fld, arrow, ind) {
        if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
            return false;
        }
        $event.preventDefault();
        if ($("typeahead-container").length > 0) {
            return false;
        }
        if (arrow == "up") ind--;
        else ind++;

        if ($("#" + fld + "-" + ind).length > 0) {
            $("#" + fld + "-" + ind).focus();
        }
    }

    finyearCombo() {
        this.combo2service.finyearCombo().then((res: any) => {
            this.finyearList = res.data
            this.masterData.finyear = res.data[0].finyear;
            this.masterData.fin_id = res.data[0].fin_id;

        })
        if (this.mode == "Add") {

            this.agentData = [{ month: 'Nov', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '11' }, { month: 'Dec', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '12' },{ month: 'Jan', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '01' }, { month: 'Feb', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '02' }, { month: 'Mar', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '03' }, { month: 'Apr', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '04' }, { month: 'May', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '05' }, { month: 'Jun', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '06' }, { month: 'July', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '07' }, { month: 'Aug', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '08' }, { month: 'Sep', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '09' }, { month: 'Oct', work_days: 0, plan_qty: 0, avg_qty: 0, month_key: '10' }];

            this.filter = { Nov: '', Dec: '' , Jan: '', Feb: '', Mar: '', Apr: '', May: '', Jun: '', Jul: '', Aug: '', Sep: '', Oct: ''};

            for (let i = 0; i <= 10; i++) {
                this.calendarData.push({ ...this.filter });
            }
            // this.ngModelValues();
            this.getcommissionMasterList();
        }
    }
    tableStyle(ind) {
        let color = ""
        if ((ind % 2) == 1) {
            color = "lightpink"
        }
        else {
            color = "bisque"
        }
        const style
            = {
            background: color
        }
        return style
    }
    //  ngModelValues(): string {
    //     console.log("check data",this.calendarData)

    //       this.calendarData.forEach((e,i) => {
    //         this.ngModelValue = Object.keys(this.calendarData[i])
    //         console.log("check",this.ngModelValue)
            
    //       });
    
    //     console.log("check",this.ngModelValue)
    //     return this.ngModelValue;
    //   }
    getAgentList() {
        let that = this;
        that.salesservice.getAgentList({}).then((res: any) => {
            this.list = res;
        });
    }

    onSelectTeam(type) {
        let data = this.list;
        this.agentList = data.filter(el => el.incharger == type);


    }
    getcommissionMasterList() {
        let that = this;
        that.salesservice.getcommissionMasterList({}).then((res: any) => {
            this.checklist = res.data;
      
        });
    }

    onSelectagent(type) {
        let data = this.list;
        let obj = data.find(o => o.name === type);

        this.masterData.agent_id = obj.genLedid;

        let chekobj = this.checklist.filter(el => el.agent_name == type);

        if (chekobj.length) {
            swal("NAME ALREADY EXIST!");
        }

    }

    viewProdPlanlist(id) {
        let params = {
            start: 0,
            limit: 100,
            page: 1,
            fin_id: id,
            type: 'entry_view'
        };
        this.salesservice
            .getFactoryProdplanList(params)
            .then((res: any) => {
                this.agentData = res.data;
                this.calendarData = res.Year_data;
                this.Selectqty(0)
            });
    }
    onnextdet() {
        this.calendar_plan = true;
        this.production_plan = false;
        this.monthList;
        this.calendarData;
    }

    onbackdet() {
        this.calendar_plan = false;
        this.production_plan = true;
    }

    addChangeDate(dt: any) {
        let ts = "T00:00:00.000Z";
        let dtfomt = dt.concat("", ts);
        let date = new Date(dtfomt);
        date.setDate(date.getDate() + 1);
        let rets = date.toLocaleDateString("fr-FR");
        let newdat = rets.split("/").reverse().join("-");
        return newdat;
    }

    oncheckemptyrow() {

        let design = this.masterData;
        let empty_check = false;

        if (!design['finyear'] || !design['effective_from']) {
            swal("PLEASE ENTER ALL THE DETAILS!");
            empty_check = true;
            // console.log(design['team'])
        }

        if (!empty_check) {

            this.onSaveOrder();
        }
    }

    onSaveOrder() {

        let params: any = Object.assign({}, this.masterData);
        params["effective_from"] = this.datePipe.transform(
            this.masterData.effective_from,
            "yyyy-MM-dd"
        );
        params['agentData'] = JSON.stringify(this.agentData);
        params['calendarData'] = JSON.stringify(this.calendarData);
        params['mode'] = this.mode;
        params['tabevent'] = undefined;
        let that = this;
        that.isLoading = true;
        if (that.mode == "Add" || that.mode == "View" || that.mode == "Edit") {
            swal({
                title: "Are you sure to save this Details?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, save it!",
                cancelButtonText: "No, want to change",
            }).then(function () {
                that.isLoading = true;
                that.salesservice
                    .addFactoryProdPlan(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (that.saveEvent) {
                            that.saveEvent.emit();
                        }
                        if (res.success) {
                            that.toasterService.pop({
                                bodyOutputType: 1,
                                type: "success",
                                title: "SUCCESS",
                                body: res.message,
                            });
                            if (that.mode == "Add" || that.mode == "View" || that.mode == "Edit") {
                                let tabObj = {
                                    action: "CloseTab",
                                    params: {},
                                };
                                that.tabUpdateEvent.emit(tabObj);
                            } else {
                                let tabObj = {
                                    action: "CloseTab",
                                    params: {},
                                };
                                that.tabUpdateEvent.emit(tabObj);
                            }
                        } else {
                            swal("ERROR", res.message, "error");
                        }
                    })
                    .catch(function (error: any) {
                        that.isLoading = false;
                        let res = JSON.parse(error._body);
                        swal("ERROR", res.message, "error");
                    });
            });
        }
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/factoryProdPlan/addFactoryProdPlan.ts